import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Grid,
  Typography,
  FormControl,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

// ----------------------------------------------------------------------

const fields = [
  { title: "Name", name: "name" },
  { title: "Point", name: "point" }
];

export default function EditRoundPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [roundId, setRoundId] = useState(false);
  const [competition, setCompetition] = useState(null);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    competition: "",
    point: 0
  });
  const [isFilled, setFilling] = useState(true);

  useEffect(() => {
    if (searchParams.has("roundId")) {
      setLoading(true);

      let roundId = searchParams.get("roundId");
      setRoundId(Number(roundId));

      const fetchDataRound = async () => {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/rounds/${roundId}`
        );
        setData(data);
        return data;
      };
      fetchDataRound()
        .finally(() => setLoading(false))
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.has("type")) {
      const competition = searchParams.get("type");
      setCompetition(competition)
      setData((prevState) => ({ ...prevState, competition }));
    }
  }, [searchParams]);

  useEffect(() => {
    const isFormFilled = fields.every((field) => {
      const value = data?.[field.name];
      return value !== null && value !== undefined && String(value).trim().length > 0;
    });
    setFilling(isFormFilled);
  }, [data]);

  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    if (!!data) {
      setLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/rounds/${roundId}`,
          data
        )
        .then(function (response) {
          navigate(`/dashboard/rounds?type=${competition}`);
        });
    }
  };
  return (
    <>
      <Helmet>
        <title> Round </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Edit Round
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                {fields.map((field) => (
                  <FormControl
                    key={field.name}
                    sx={{ m: 1, minWidth: 620 }}
                    size="small"
                  >
                    <TextField
                      required
                      label={field.title}
                      placeholder={field.title}
                      name={field.name}
                      value={data[field.name] || ""}
                      onChange={(e) => handleChange(e)}
                      variant="outlined"
                    />
                  </FormControl>
                ))}
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  disabled={!isFilled}
                  onClick={() => handleSubmit()}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
